import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getQuotes as getQuotesApi,
  addNewQuote as addNewQuoteApi,
  updateQuote as updateQuoteApi,
  deleteQuote as deleteQuoteApi,
  getWebQuotation as getWebQuotationApi,
  addNewWebQuotation as addNewWebQuotationApi,
  updateWebQuotation as updateWebQuotationApi,
  deleteWebQuotation as deleteWebQuotationApi,
} from "../../helpers/realbackend_helper";

export const getQuotes = createAsyncThunk(
  "quote/getQuotes",
  async ({ beginDate, lastDate, employee }, { rejectWithValue }) => {
    try {
      const response = await getQuotesApi(beginDate, lastDate, employee);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Quotes");
    }
  }
);

export const addNewQuote = createAsyncThunk(
  "quote/addNewQuote",
  async (quote) => {
    try {
      const response = addNewQuoteApi(quote);
      toast.success("Үнийн саналыг амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Үнийн санал бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateQuote = createAsyncThunk(
  "quote/updateQuote",
  async (quote) => {
    try {
      const response = updateQuoteApi(quote);
      toast.success("Үнийн саналыг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Үнийн саналыг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteQuote = createAsyncThunk(
  "quote/deleteQuote",
  async (id, { rejectWithValue }) => {
    try {
      await deleteQuoteApi(id);

      toast.success("Үнийн саналыг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Үнийн саналыг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);

export const getWebQuotation = createAsyncThunk(
  "quote/getWebQuotation",
  async ({ beginDate, lastDate, employee }, { rejectWithValue }) => {
    try {
      const response = await getWebQuotationApi(beginDate, lastDate, employee);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch Quotes");
    }
  }
);

export const addNewWebQuotation = createAsyncThunk(
  "quote/addNewWebQuotation",
  async (wquote) => {
    try {
      const response = addNewWebQuotationApi(wquote);
      toast.success("Үнийн саналыг амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Үнийн санал бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateWebQuotation = createAsyncThunk(
  "quote/updateWebQuotation",
  async (wquote) => {
    try {
      const response = updateWebQuotationApi(wquote);
      toast.success("Үнийн саналыг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Үнийн саналыг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteWebQuotation = createAsyncThunk(
  "quote/deleteWebQuotation",
  async (id, { rejectWithValue }) => {
    try {
      await deleteWebQuotationApi(id);

      toast.success("Үнийн саналыг амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Үнийн саналыг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);
